import React from 'react';

import { useIntl } from 'react-intl';

import { FilterProductIcon } from '../../../../../common/ui/filters/filter-product-icon';
import type { FilterProps } from '../../../../../common/ui/filters/product-filters/types';
import { ToggleFilter } from '../../../../../common/ui/filters/toggle-filter';
import { useBooleanFilter } from '../../../../../controllers/filters/boolean-filter';
import { usePrimaryProduct } from '../../../../../controllers/store/bootstrap';
import { filter as verifiedFilter } from '../../../../../controllers/store/search/filters/verified';

import { i18n } from './messages';

export type VerifiedFilterProps = {
	isFilterInDropdown?: boolean;
};

const VerifiedFilter = ({
	isFilterInDropdown = false,
	showPrimaryProductIcon,
	onFilterChange,
}: FilterProps): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const [primaryProduct] = usePrimaryProduct();
	const [state, { toggle }] = useBooleanFilter({
		filterId: verifiedFilter.id,
	});

	if (!state) {
		return null;
	}

	const { value, autoFocus } = state;

	return (
		<ToggleFilter
			onChange={() => {
				onFilterChange?.({ isSelected: value });
				toggle();
			}}
			isChecked={value}
			autoFocus={autoFocus}
			isFilterInDropdown={isFilterInDropdown}
			iconBefore={
				<FilterProductIcon
					primaryProduct={primaryProduct}
					showPrimaryProductIcon={showPrimaryProductIcon}
				/>
			}
		>
			{formatMessage(i18n.verified)}
		</ToggleFilter>
	);
};

export default VerifiedFilter;
